module.exports = __webpack_public_path__ + "img/charles-calvert.9baea62b.png";